import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const AddEditWorkHistoryJobModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "AddEditWorkHistoryJobModalContainer" */
      './AddEditWorkHistoryJobModalContainer'
    ),
  loading: LoadingModal,
});
